import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FeesListDG from './components/FeesListDG'

import { getCookie } from "utils/cookies";
import { getOneOperatorApi } from "api/operator";
import { Spinner } from "@material-tailwind/react";

function CompanyFeesDg() {
  const { userID } = useParams();
  const [accessList, setAccessList] = useState({})
  const [isLoading, setIsLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    getAccessList()
  }, [])

  const fullAccessObject = {
    Add: true,
    Read: true,
    Update: true,
    Delete: true,

    VehicleCharges: true,
    TravellingExpenses: true,
    LocalTransportationCosts: true,
    EvenementsExpenses: true,
    AvocatExpenses: true,

    Validation: true,

    DynamicCategories: "ALL",
  }

  const getAccessList = async () => {
    try {
      setIsLoading(true)

      const id = getCookie("3F2Mb2pJ1YRro5Z4")
      const adminRole = getCookie("lv9u765qzk1gr4fn1e")

      if(adminRole === "FALSE") {
        const response = await getOneOperatorApi(id)

        // Unlike /admin/CompanyFeeDg/ (the DG's own sign-off page), this page
        // is the first-level, per-category "dynamicValidationStatus"
        // validation. Each category has exactly one assigned tcp, so a DG
        // operator must NOT get the "sees everything" bypass here — only the
        // true superadmin does (handled below). DG falls through to the same
        // role-access-based branch as any other operator.
        setIsAdmin(false)

        const accessList = response.userFromRole.access

        const selectedAccessDetails = accessList.find(el => el.value._id == userID)

        const accessObject = {
          Add: false,
          Read: false,
          Update: false,
          Delete: false,

          VehicleCharges: false,
          TravellingExpenses: false,
          LocalTransportationCosts: false,
          EvenementsExpenses: false,
          AvocatExpenses: false,

          Validation: false,

          DynamicCategories: [],
        }

        selectedAccessDetails.sectionItems.map(el => {
          if(el.value == "Add" && el.checked) {
            accessObject.Add = true
          }
          if(el.value == "Read" && el.checked) {
            accessObject.Read = true
          }
          if(el.value == "Update" && el.checked) {
            accessObject.Update = true
          }
          if(el.value == "Delete" && el.checked) {
            accessObject.Delete = true
          }

          if(el.value == "VehicleCharges" && el.checked) {
            accessObject.VehicleCharges = true
          }
          if(el.value == "TravellingExpenses" && el.checked) {
            accessObject.TravellingExpenses = true
          }
          if(el.value == "LocalTransportationCosts" && el.checked) {
            accessObject.LocalTransportationCosts = true
          }
          if(el.value == "EvenementsExpenses" && el.checked) {
            accessObject.EvenementsExpenses = true
          }
          if(el.value == "AvocatExpenses" && el.checked) {
            accessObject.AvocatExpenses = true
          }
          if(el.value == "Validation" && el.checked) {
            accessObject.Validation = true
          }

          if(el.value?.startsWith?.("DYNAMIC:") && el.checked) {
            accessObject.DynamicCategories.push(el.value.split(":")[1])
          }
        })

        setAccessList({
          Add: accessObject.Add,
          Read: accessObject.Read,
          Update: accessObject.Update,
          Delete: accessObject.Delete,

          VehicleCharges: accessObject.VehicleCharges,
          TravellingExpenses: accessObject.TravellingExpenses,
          LocalTransportationCosts: accessObject.LocalTransportationCosts,
          EvenementsExpenses: accessObject.EvenementsExpenses,
          AvocatExpenses: accessObject.AvocatExpenses,

          Validation: accessObject.Validation,

          DynamicCategories: accessObject.DynamicCategories,
        })
      }
      else if(adminRole === "TRUE") {
        setIsAdmin(true)
        setIsSuperAdmin(true)
        setAccessList(fullAccessObject)
      }
    }
    catch (err) {
      console.log(err)
    }
    finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
        {
        isLoading ?
        <div className="flex items-center justify-center">
          <Spinner className="h-12 w-12" />
        </div> :
        <FeesListDG accessList={accessList} isAdmin={isAdmin} isSuperAdmin={isSuperAdmin} />
      }
    </div>
  )
}

export default CompanyFeesDg
